import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import professionCases from 'helpers/professionCases';

const Title = styled(Typography)(({ theme }) => ({
  padding: '11px 25px 10px',
  fontSize: 24,
  textAlign: 'center',
  borderBottom: '1px solid #d6d6d6',
  [theme.breakpoints.down('md')]: {
    lineHeight: '34px'
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left'
  }
}));

const Text = styled(Typography)(({ theme }) => ({
  padding: '16px 25px',
  '& span': {
    display: 'block',
    marginBottom: 15
  },
  fontSize: 16,
  [theme.breakpoints.down('md')]: {
    padding: '16px 25px'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '16px 25px'
  }
}));

const DescriptionSlideComponent = ({ professionInfo, t }) => {
  return (
    <>
      <Title variant={'h1'}>{t('WhoIs', professionCases(professionInfo, 'nominative'))}</Title>

      <Text variant="body1">
        {(professionInfo?.descriptionFull || '').split('\n\n').map((paragraph, index) => (
          <span key={index}>{paragraph}</span>
        ))}
      </Text>
    </>
  );
};

export default DescriptionSlideComponent;
